import React from "react";
import { Trash2, CopyPlus, Plus } from "lucide-react";

const NodeActionButtons = ({ id, data }) => (
  <>
    <div className="absolute -top-2.5 -right-2.5 z-20 flex gap-0.5">
      <button
        onClick={(e) => {
          e.stopPropagation();
          data.onDuplicateNode?.(id);
        }}
        className="p-1 bg-white rounded-full shadow border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-colors"
        title="Duplicate node"
      >
        <CopyPlus size={11} className="text-blue-600" />
      </button>
      <button
        onClick={(e) => {
          e.stopPropagation();
          data.onDeleteNode?.(id);
        }}
        className="p-1 bg-white rounded-full shadow border border-gray-200 hover:border-red-300 hover:bg-red-50 transition-colors"
        title="Delete node"
      >
        <Trash2 size={11} className="text-red-600" />
      </button>
    </div>

    {data.canAddNext !== false && (
      <button
        onClick={(e) => {
          e.stopPropagation();
          data.onOpenAddNodeMenu?.(id, e);
        }}
        className="absolute -bottom-3 left-1/2 -translate-x-1/2 z-20 flex items-center justify-center w-6 h-6 bg-white rounded-full shadow-md border-2 border-indigo-200 hover:border-indigo-400 hover:bg-indigo-50 transition-all group"
        title="Add next node"
      >
        <Plus size={13} className="text-indigo-600 group-hover:scale-110 transition-transform" />
      </button>
    )}
  </>
);

export default NodeActionButtons;
